import React from "react";

const PASOS = [
  "Datos",
  "Contacto",
  "Profesión",
  "Formación",
  "Certificaciones",
  "Experiencia",
  "Documentos",
  "Pago",
  "Declaración",
  "Revisión",
];

const DOCUMENTOS = [
  ["cedula", "Cédula"],
  ["pasaporte", "Pasaporte"],
  ["idoneidad", "Idoneidad profesional"],
  ["hoja_vida", "Hoja de vida"],
  ["record_policivo", "Récord policivo"],
];

function calcularEdad(fecha) {
  if (!fecha) return "";
  var nacimiento = new Date(fecha + "T00:00:00");
  if (isNaN(nacimiento.getTime())) return "";
  var hoy = new Date();
  var edad = hoy.getFullYear() - nacimiento.getFullYear();
  var mes = hoy.getMonth() - nacimiento.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) edad -= 1;
  return edad >= 0 ? String(edad) : "";
}

function Firma(props) {
  var lienzoRef = React.useRef(null);
  var trazando = React.useRef(false);
  var previo = React.useRef(null);
  var alCambiar = React.useRef(props.onChange);
  alCambiar.current = props.onChange;

  React.useEffect(function () {
    var lienzo = lienzoRef.current;
    if (!lienzo) return;
    var ctx = lienzo.getContext("2d");
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1e2430";
    function punto(evento) {
      var recta = lienzo.getBoundingClientRect();
      return {
        x: (evento.clientX - recta.left) * (lienzo.width / recta.width),
        y: (evento.clientY - recta.top) * (lienzo.height / recta.height),
      };
    }
    function iniciar(evento) {
      trazando.current = true;
      previo.current = punto(evento);
    }
    function mover(evento) {
      if (!trazando.current) return;
      evento.preventDefault();
      var actual = punto(evento);
      ctx.beginPath();
      ctx.moveTo(previo.current.x, previo.current.y);
      ctx.lineTo(actual.x, actual.y);
      ctx.stroke();
      previo.current = actual;
    }
    function soltar() {
      if (!trazando.current) return;
      trazando.current = false;
      alCambiar.current(lienzo.toDataURL("image/png"));
    }
    lienzo.addEventListener("pointerdown", iniciar);
    lienzo.addEventListener("pointermove", mover);
    lienzo.addEventListener("pointerup", soltar);
    lienzo.addEventListener("pointerleave", soltar);
    return function () {
      lienzo.removeEventListener("pointerdown", iniciar);
      lienzo.removeEventListener("pointermove", mover);
      lienzo.removeEventListener("pointerup", soltar);
      lienzo.removeEventListener("pointerleave", soltar);
    };
  }, [props.repetir]);

  if (!props.repetir && props.url) {
    return (
      <div className="firma-caja">
        <img className="firma-previa" src={props.url} alt="Firma registrada" />
        <button type="button" className="boton-secundario" onClick={props.alRepetir}>
          Firmar de nuevo
        </button>
      </div>
    );
  }

  return (
    <div className="firma-caja">
      <canvas ref={lienzoRef} width="900" height="280" className="firma-lienzo" />
      <button type="button" className="boton-secundario" onClick={props.alBorrar}>
        Borrar firma
      </button>
    </div>
  );
}

export default function PlanillaForm(props) {
  var planilla = props.planilla;
  var paso = props.paso;

  function campo(etiqueta, nombre, tipo) {
    return (
      <label className="campo">
        <span>{etiqueta}</span>
        <input
          type={tipo || "text"}
          value={planilla[nombre] || ""}
          onChange={function (e) {
            props.cambiar(nombre, e.target.value);
          }}
        />
      </label>
    );
  }

  function grupo(grupoNombre, campoNombre, etiqueta) {
    var origen = planilla[grupoNombre] || {};
    return (
      <label className="campo">
        <span>{etiqueta}</span>
        <input
          value={origen[campoNombre] || ""}
          onChange={function (e) {
            props.cambiarGrupo(grupoNombre, campoNombre, e.target.value);
          }}
        />
      </label>
    );
  }

  function medio(clave, etiqueta) {
    return (
      <label className="grupo-check">
        <input
          type="checkbox"
          checked={Number(planilla.pago[clave]) === 1}
          onChange={function () {
            props.cambiarGrupo("pago", clave, Number(planilla.pago[clave]) === 1 ? 0 : 1);
          }}
        />
        <span>{etiqueta}</span>
      </label>
    );
  }

  function filas(lista, columnas, muestra, clase) {
    return (
      <div className="rejilla">
        {planilla[lista].map(function (fila, indice) {
          return (
            <div className={"fila-repetible " + clase} key={lista + indice}>
              {columnas.map(function (columna) {
                return (
                  <label className="campo" key={columna[0]}>
                    <span>{columna[1]}</span>
                    <input
                      type={columna[2] || "text"}
                      value={fila[columna[0]] || ""}
                      onChange={function (e) {
                        props.cambiarFila(lista, indice, columna[0], e.target.value);
                      }}
                    />
                  </label>
                );
              })}
              <button type="button" className="boton-secundario" onClick={function () { props.quitarFila(lista, indice, muestra); }}>
                Quitar
              </button>
            </div>
          );
        })}
        <button type="button" className="boton-secundario" onClick={function () { props.agregarFila(lista, muestra); }}>
          Agregar otra
        </button>
      </div>
    );
  }

  function docNombre(tipo) {
    var doc = (planilla.documentos || []).find(function (item) {
      return item.tipo === tipo;
    });
    return doc ? doc.nombre_original : "";
  }

  return (
    <div className="esp-modulo">
      <div className="contenedor">
        <div className="encabezado-pagina">
          <div>
            <button type="button" className="boton-secundario" onClick={props.volver}>
              Volver a la lista
            </button>
            <h1>{planilla.nombre_completo || "Planilla del especialista"}</h1>
            <p>Completa los datos y guárdalos. Puedes corregirlos y volver a guardarlos; los cambios se actualizan en miperfil.</p>
          </div>
          <div className="esp-cabecera-acciones">
            <button type="button" className="boton-secundario" onClick={props.imprimir}>
              Imprimir
            </button>
            <button type="button" className="boton-peligro" onClick={props.eliminar} disabled={props.cargando}>
              Eliminar
            </button>
          </div>
        </div>
        {props.mensaje ? <p className="error">{props.mensaje}</p> : null}
        {props.aviso ? <div className="banner ok">{props.aviso}</div> : null}
        {props.cargando ? <p className="ayuda">Guardando…</p> : null}

        <div className="pasos">
          {PASOS.map(function (nombre, indice) {
            return (
              <button key={nombre} type="button" className={paso === indice ? "actual" : ""} onClick={function () { props.setPaso(indice); }}>
                {indice + 1}. {nombre}
              </button>
            );
          })}
        </div>

        <section className="tarjeta">
          {paso === 0 ? (
            <div className="rejilla rejilla-datos">
              <div className="bloque-foto">
                {planilla.tieneFoto ? (
                  <img className="foto-previa" src={props.archivoUrl("foto")} alt="Fotografía" />
                ) : (
                  <div className="foto-previa" />
                )}
                <label className="boton-secundario">
                  Subir foto
                  <input type="file" accept="image/jpeg,image/png" hidden onChange={function (e) { props.subir("foto", e.target.files[0]); }} />
                </label>
                <p className="ayuda">JPG o PNG, máximo 2 MB.</p>
              </div>
              <div className="rejilla rejilla-2">
                {campo("Nombre completo", "nombre_completo")}
                {campo("Apellido", "apellido")}
                {campo("Cédula", "cedula")}
                {campo("Pasaporte", "pasaporte")}
                {campo("Fecha de nacimiento", "fecha_nacimiento", "date")}
                <label className="campo">
                  <span>Edad</span>
                  <input value={calcularEdad(planilla.fecha_nacimiento)} readOnly />
                </label>
                {campo("Nacionalidad", "nacionalidad")}
                {campo("País de residencia", "pais_residencia")}
              </div>
            </div>
          ) : null}

          {paso === 1 ? (
            <div className="rejilla rejilla-2">
              {campo("Teléfono o WhatsApp", "telefono")}
              {campo("Correo electrónico", "correo", "email")}
              {campo("Provincia o estado", "provincia")}
              {campo("Ciudad o distrito", "ciudad")}
              {campo("Dirección o ubicación", "direccion")}
            </div>
          ) : null}

          {paso === 2 ? (
            <div className="rejilla">
              <div className="rejilla rejilla-3">
                {campo("Profesión", "profesion")}
                {campo("Especialidad o área", "especialidad")}
                {campo("Años de experiencia", "anos_experiencia", "number")}
              </div>
              <div className="rejilla rejilla-2">
                {campo("Idoneidad profesional N.°", "idoneidad_numero")}
                {campo("País donde está habilitado", "pais_habilitado")}
              </div>
              <label className="campo">
                <span>Resumen profesional</span>
                <textarea
                  value={planilla.resumen_profesional}
                  onChange={function (e) { props.cambiar("resumen_profesional", e.target.value); }}
                />
              </label>
            </div>
          ) : null}

          {paso === 3
            ? filas("formacion", [
                ["titulo", "Título"],
                ["institucion", "Institución"],
                ["pais", "País"],
                ["anio", "Año"],
              ], { titulo: "", institucion: "", pais: "", anio: "" }, "cuatro")
            : null}

          {paso === 4
            ? filas("certificaciones", [
                ["nombre", "Certificación, diplomado o curso"],
                ["institucion", "Institución"],
                ["pais", "País"],
                ["anio", "Año"],
              ], { nombre: "", institucion: "", pais: "", anio: "" }, "cuatro")
            : null}

          {paso === 5
            ? filas("experiencia", [
                ["cargo", "Cargo"],
                ["empresa", "Empresa o institución"],
                ["pais", "País"],
                ["fecha_desde", "Desde", "date"],
                ["fecha_hasta", "Hasta", "date"],
              ], { cargo: "", empresa: "", pais: "", fecha_desde: "", fecha_hasta: "" }, "experiencia")
            : null}

          {paso === 6 ? (
            <div className="rejilla">
              <p className="ayuda">PDF, JPG o PNG. Cada documento puede pesar hasta 5 MB.</p>
              {DOCUMENTOS.map(function (item) {
                var nombre = docNombre(item[0]);
                return (
                  <div className="tarjeta" key={item[0]}>
                    <strong>{item[1]}</strong>
                    <p>
                      {nombre ? (
                        <a href={props.archivoUrl(item[0])} target="_blank" rel="noreferrer">{nombre}</a>
                      ) : (
                        "Pendiente"
                      )}
                    </p>
                    <label className="boton-secundario">
                      Adjuntar
                      <input hidden type="file" accept="application/pdf,image/jpeg,image/png" onChange={function (e) { props.subir(item[0], e.target.files[0]); }} />
                    </label>
                  </div>
                );
              })}
            </div>
          ) : null}

          {paso === 7 ? (
            <div className="rejilla">
              <p className="ayuda">Indica los medios por los que puede recibir el pago. Puedes marcar más de uno.</p>
              {medio("transferencia", "Transferencia bancaria")}
              {Number(planilla.pago.transferencia) === 1 ? (
                <div className="rejilla rejilla-2">
                  {grupo("transferencia", "titular", "Titular de la cuenta")}
                  {grupo("transferencia", "banco", "Banco")}
                  <label className="campo">
                    <span>Tipo de cuenta</span>
                    <select
                      value={planilla.transferencia.tipo_cuenta || "ahorros"}
                      onChange={function (e) { props.cambiarGrupo("transferencia", "tipo_cuenta", e.target.value); }}
                    >
                      <option value="ahorros">Ahorros</option>
                      <option value="corriente">Corriente</option>
                    </select>
                  </label>
                  {grupo("transferencia", "numero_cuenta", "Número de cuenta")}
                  {grupo("transferencia", "pais", "País")}
                </div>
              ) : null}
              {medio("yappy", "Yappy")}
              {Number(planilla.pago.yappy) === 1 ? (
                <div className="rejilla rejilla-2">
                  {grupo("yappy", "nombre_titular", "Nombre del titular")}
                  {grupo("yappy", "numero", "Número asociado")}
                </div>
              ) : null}
              {medio("western", "Western Union")}
              {Number(planilla.pago.western) === 1 ? (
                <div className="rejilla rejilla-2">
                  {grupo("western", "nombre_beneficiario", "Nombre del beneficiario")}
                  {grupo("western", "cedula_pasaporte", "Cédula o pasaporte")}
                  {grupo("western", "pais", "País donde recibe")}
                  {grupo("western", "ciudad", "Ciudad")}
                  {grupo("western", "telefono", "Teléfono")}
                </div>
              ) : null}
              {medio("efectivo", "Efectivo")}
              {medio("otro", "Otro")}
              {Number(planilla.pago.otro) === 1 ? (
                <div className="rejilla">
                  <label className="campo">
                    <span>Descripción</span>
                    <input
                      value={planilla.pago.otro_descripcion || ""}
                      onChange={function (e) { props.cambiarGrupo("pago", "otro_descripcion", e.target.value); }}
                    />
                  </label>
                  {grupo("otro_pago", "metodo", "Método")}
                  <label className="campo">
                    <span>Datos necesarios para realizar el pago</span>
                    <textarea
                      value={planilla.otro_pago.datos || ""}
                      onChange={function (e) { props.cambiarGrupo("otro_pago", "datos", e.target.value); }}
                    />
                  </label>
                </div>
              ) : null}
            </div>
          ) : null}

          {paso === 8 ? (
            <div className="rejilla">
              <p>Declaro que la información y documentación suministradas en esta planilla son verdaderas, correctas y se encuentran vigentes. Autorizo el uso de estos datos para fines administrativos, profesionales y de pago relacionados con la prestación de mis servicios.</p>
              <label className="grupo-check">
                <input
                  type="checkbox"
                  checked={Number(planilla.declaracion_aceptada) === 1}
                  onChange={function (e) { props.cambiar("declaracion_aceptada", e.target.checked ? 1 : 0); }}
                />
                <span>Acepto la declaración</span>
              </label>
              {campo("Nombre completo", "nombre_declaracion")}
              {campo("Fecha", "fecha_declaracion", "date")}
              <div>
                <span className="campo"><span>Firma</span></span>
                <Firma
                  url={planilla.tieneFirma ? props.archivoUrl("firma") : ""}
                  repetir={props.repetirFirma || planilla.firma !== "mantener"}
                  alRepetir={function () { props.setRepetirFirma(true); props.cambiar("firma", ""); }}
                  alBorrar={function () { props.cambiar("firma", ""); props.cambiar("tieneFirma", false); props.setRepetirFirma(true); }}
                  onChange={function (valor) { props.cambiar("firma", valor); }}
                />
              </div>
            </div>
          ) : null}

          {paso === 9 ? (
            <div className="rejilla">
              <p><strong>{[planilla.nombre_completo, planilla.apellido].filter(Boolean).join(" ")}</strong></p>
              <p>Cédula: {planilla.cedula || "—"} · Pasaporte: {planilla.pasaporte || "—"}</p>
              <p>{planilla.profesion} · {planilla.especialidad}</p>
              <p>{planilla.correo} · {planilla.telefono}</p>
              <p className="ayuda">Al guardar, la planilla se actualiza en miperfil.</p>
            </div>
          ) : null}

          <div className="fila-botones">
            {paso > 0 ? (
              <button type="button" className="boton-secundario" onClick={function () { props.setPaso(paso - 1); }}>
                Atrás
              </button>
            ) : null}
            {paso < 9 ? (
              <button type="button" className="boton-secundario" onClick={function () { props.setPaso(paso + 1); }}>
                Siguiente
              </button>
            ) : null}
            <button type="button" className="boton" disabled={props.cargando} onClick={props.guardar}>
              {props.cargando ? "Guardando…" : "Guardar"}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
